import { colors } from '@cobliteam/ui/theme';
import { css } from 'emotion';

const tooltip = css`
  > div {
    background-color: ${colors.black.a10};
    color: ${colors.white.DEFAULT};
    border: none;
    border-radius: 5px;
    padding: 5px 10px;
    white-space: normal;
    min-width: 180px;
    max-width: 260px;

    ::before {
      border-bottom-color: ${colors.black.a10};
    }
  }
`;

const layer = (color: string, fill?: string) => css`
  fill: ${fill || color} !important;
  stroke: ${color} !important;
  stroke-width: 3 !important;
`;

export default { tooltip, layer };
